import React, { useState } from 'react';
import { Button, Container, Form, FormControl, InputGroup } from 'react-bootstrap';
import { useAuth } from '../../Context/AuthContext';
import '../../style/style.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { onLogin, user, onRegister, onForgotPassword } = useAuth();

  const handleLogin = async () => {
    try {
      if (!onLogin || !email || !password) {
        alert('Fill in everything');
        return;
      }
      await onLogin(email, password);
    } catch (err) {
      if ((err as any).toString().includes('user-not-found')) {
        alert('Error: User not found');
      } else {
        alert((err as any).toString());
      }
      console.log(err);
    }
  };

  const handleResetPassword = async () => {
    if (window.confirm(`Send a password reset email to ${email}?`)) {
      onForgotPassword && onForgotPassword(email);
    }
  };

  return (
    <Container style={{ marginTop: '8%' }}>
      <div className="centerItem">
        <img src="/main-logo.png" width="180px" height="auto" />
      </div>
      <br></br>
      <br></br>
      <Form className="loginBox">
        <fieldset>
          <Form.Group className="mb-3 centerItem">
            <Form.Label htmlFor="inputEmail" className="smallTitle">
              Email
            </Form.Label>
            <InputGroup className="mb-3 loginInput">
              <FormControl
                placeholder="email"
                aria-label="Email"
                aria-describedby="basic-addon2"
                value={email}
                onChange={(event) => {
                  event.persist();
                  const value = event.target.value || '';
                  setEmail(value);
                }}
              />
              {/*<InputGroup.Text id="basic-addon2">@sitikhadijah.com</InputGroup.Text>*/}
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3 centerItem">
            <Form.Label htmlFor="inputPassword" className="smallTitle">
              Password
            </Form.Label>
            <Form.Control
              placeholder="password"
              value={password}
              type="password"
              id="inputPassword"
              onChange={(event) => {
                event.persist();
                setPassword(event.target.value);
              }}
              className="loginInput"
            />
          </Form.Group>
          <div className="centerItem">
            <Button
              onClick={(event) => {
                event.preventDefault();
                handleLogin();
              }}
              type="submit"
              className="loginBtn"
              variant="light"
            >
              Login
            </Button>
          </div>
          <div className="centerItem" style={{ fontSize: '13px', margin: '10px' }}>
            <span style={{ cursor: 'pointer' }} onClick={handleResetPassword}>
              Forgot Password?
            </span>
          </div>
        </fieldset>
      </Form>
    </Container>
  );
};

export default Login;
